import Vue from 'vue'
import VueRouter from "vue-router"
import token from "./token"

Vue.use(VueRouter)
//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
	routes: [
		/* 前端首页 */
		{
			path: '/',
			name: 'fIndex',
			component: () => import('./views/front/Index.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端前端首页 */
		{
			// path: '/phone/index',
			path: '/phoneIndex',
			name: 'pIndex',
			component: () => import('./views/phone/Index.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端律所简介 */
		{
			// path: '/phone/aboutUs',
			path: '/phoneAboutUs',
			name: 'pAboutUs',
			component: () => import('./views/phone/aboutUs.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端发展历程 */
		{
			// path: '/phone/developmentHistory',
			path: '/phoneDevelopmentHistory',
			name: 'pDevelopmentHistory',
			component: () => import('./views/phone/developmentHistory.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端荣誉奖项 */
		{
			// path: '/phone/honoraryAwards',
			path: '/phoneHonoraryAwards',
			name: 'pHonoraryAwards',
			component: () => import('./views/phone/honoraryAwards.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端红色建设 */
		{
			// path: '/phone/redConstruction',
			path: '/phoneRedConstruction',
			name: 'pRedConstruction',
			component: () => import('./views/phone/redConstruction.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端红色建设详情 */
		{
			// path: '/phone/redConstructionDetail',
			path: '/phoneRedConstructionDetail',
			name: 'pRedConstructionDetail',
			component: () => import('./views/phone/redConstructionDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端和华文化 */
		{
			// path: '/phone/hehuaCulture',
			path: '/phoneHehuaCulture',
			name: 'pHehuaCulture',
			component: () => import('./views/phone/hehuaCulture.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端和华文化详情 */
		{
			// path: '/phone/hehuaCultureDetail',
			path: '/phoneHehuaCultureDetail',
			name: 'pHehuaCultureDetail',
			component: () => import('./views/phone/hehuaCultureDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端业务领域 */
		{
			// path: '/phone/businessArea',
			path: '/phoneBusinessArea',
			name: 'pBusinessArea',
			component: () => import('./views/phone/businessArea.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端业务领域详情 */
		{
			// path: '/phone/businessAreaDetail',
			path: '/phoneBusinessAreaDetail',
			name: 'pBusinessAreaDetail',
			component: () => import('./views/phone/businessAreaDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端专业人员 */
		{
			// path: '/phone/professional',
			path: '/phoneProfessional',
			name: 'pProfessional',
			component: () => import('./views/phone/professional.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端专业人员详情 */
		{
			// path: '/phone/professionalDetail',
			path: '/phoneProfessionalDetail',
			name: 'pProfessionalDetail',
			component: () => import('./views/phone/professionalDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端资讯动态 */
		{
			// path: '/phone/news',
			path: '/phoneNews',
			name: 'pNews',
			component: () => import('./views/phone/news.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端资讯动态详情 */
		{
			// path: '/phone/newsDetail',
			path: '/phoneNewsDetail',
			name: 'pNewsDetail',
			component: () => import('./views/phone/newsDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端经典案例 */
		{
			// path: '/phone/classicCases',
			path: '/phoneClassicCases',
			name: 'pClassicCases',
			component: () => import('./views/phone/classicCases.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端经典案例详情 */
		{
			// path: '/phone/classicCasesDetail',
			path: '/phoneClassicCasesDetail',
			name: 'pClassicCasesDetail',
			component: () => import('./views/phone/classicCasesDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端专业文章 */
		{
			// path: '/phone/professionalArticles',
			path: '/phoneProfessionalArticles',
			name: 'pProfessionalArticles',
			component: () => import('./views/phone/professionalArticles.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端专业文章详情 */
		{
			// path: '/phone/professionalArticlesDetail',
			path: '/phoneProfessionalArticlesDetail',
			name: 'pProfessionalArticlesDetail',
			component: () => import('./views/phone/professionalArticlesDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端联系我们 */
		{
			// path: '/phone/contactUs',
			path: '/phoneContactUs',
			name: 'pContactUs',
			component: () => import('./views/phone/contactUs.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端加入我们 */
		{
			// path: '/phone/joinUs',
			path: '/phoneJoinUs',
			name: 'pJoinUs',
			component: () => import('./views/phone/joinUs.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端加入我们详情 */
		{
			// path: '/phone/joinUsDetail',
			path: '/phoneJoinUsDetail',
			name: 'pJoinUsDetail',
			component: () => import('./views/phone/joinUsDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端免责条款 */
		{
			// path: '/phone/disclaimer',
			path: '/phoneDisclaimer',
			name: 'pDisclaimer',
			component: () => import('./views/phone/disclaimer.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端隐私政策 */
		{
			// path: '/phone/privacyPolicy',
			path: '/phonePrivacyPolicy',
			name: 'pPrivacyPolicy',
			component: () => import('./views/phone/privacyPolicy.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 暂未开放 */
		{
			path: '/notOpen',
			name: 'notOpen',
			component: () => import('./views/front/notOpen.vue'),
			meta: {
				requireLogin: false
			}
		}, 
		/* 关于我们主页 */
		{
			path: '/aboutUs',
			name: 'aboutUs',
			component: () => import('./views/front/aboutUs.vue'),
			meta: {
				requireLogin: false
			}
		}, 
		/* 发展历程主页 */
		{
			path: '/developmentHistory',
			name: 'developmentHistory',
			component: () => import('./views/front/developmentHistory.vue'),
			meta: {
				requireLogin: false
			}
		}, 
		/* 荣誉奖项主页 */
		{
			path: '/honoraryAwards',
			name: 'honoraryAwards',
			component: () => import('./views/front/honoraryAwards.vue'),
			meta: {
				requireLogin: false
			}
		}, 
		/* 红色建设主页 */
		{
			path: '/redConstruction',
			name: 'redConstruction',
			component: () => import('./views/front/redConstruction.vue'),
			meta: {
				requireLogin: false
			}
		}, 
		/* 红色建设详情 */
		{
			path: '/redConstructionDetail',
			name: 'redConstructionDetail',
			component: () => import('./views/front/redConstructionDetail.vue'),
			meta: {
				requireLogin: false
			}
		},
		/* 和华文化主页 */
		{
			path: '/hehuaCulture',
			name: 'hehuaCulture',
			component: () => import('./views/front/hehuaCulture.vue'),
			meta: {
				requireLogin: false
			}
		}, 
		/* 和华文化详情 */
		{
			path: '/hehuaCultureDetail',
			name: 'hehuaCultureDetail',
			component: () => import('./views/front/hehuaCultureDetail.vue'),
			meta: {
				requireLogin: false
			}
		}, 
		/* 业务领域主页 */
		{
			path: '/businessArea',
			name: 'businessArea',
			component: () => import('./views/front/businessArea.vue'),
			meta: {
				requireLogin: false
			}
		},
		/* 业务领域详情 */
		{
			path: '/businessAreaDetail',
			name: 'businessAreaDetail',
			component: () => import('./views/front/businessAreaDetail.vue'),
			meta: {
				requireLogin: false
			}
		}, 
		/* 专业人员主页 */
		{
			path: '/professional',
			name: 'professional',
			component: () => import('./views/front/professional.vue'),
			meta: {
				requireLogin: false
			}
		},
		/* 专业人员详情 */
		{
			path: '/professionalDetail',
			name: 'professionalDetail',
			component: () => import('./views/front/professionalDetail.vue'),
			meta: {
				requireLogin: false,
				keepAlive:false
			}
		}, 
		/* 动态资讯主页 */
		{
			path: '/news',
			name: 'news',
			component: () => import('./views/front/news.vue'),
			meta: {
				requireLogin: false
			}
		},
		/* 经典案例主页 */
		{
			path: '/classicCases',
			name: 'classicCases',
			component: () => import('./views/front/classicCases.vue'),
			meta: {
				requireLogin: false
			}
		},
		/* 专业文章主页 */
		{
			path: '/professionalArticles',
			name: 'professionalArticles',
			component: () => import('./views/front/professionalArticles.vue'),
			meta: {
				requireLogin: false
			}
		},
		/* 动态资讯详情 */
		{
			path: '/newsDetail',
			name: 'newsDetail',
			component: () => import('./views/front/newsDetail.vue'),
			meta: {
				requireLogin: false,
				keepAlive:false
			}
		}, 
		/* 联系我们主页 */
		{
			path: '/contactUs',
			name: 'contactUs',
			component: () => import('./views/front/contactUs.vue'),
			meta: {
				requireLogin: false,
				keepAlive:false
			}
		}, 
		/* 加入我们主页 */
		{
			path: '/joinUs',
			name: 'joinUs',
			component: () => import('./views/front/joinUs.vue'),
			meta: {
				requireLogin: false,
				keepAlive:false
			}
		}, 
		/* 加入我们详情 */
		{
			path: '/joinUsDetail',
			name: 'joinUsDetail',
			component: () => import('./views/front/joinUsDetail.vue'),
			meta: {
				requireLogin: false,
				keepAlive:false
			}
		}, 
		/* 免责条款 */
		{
			path: '/disclaimer',
			name: 'disclaimer',
			component: () => import('./views/front/disclaimer.vue'),
			meta: {
				requireLogin: false,
				keepAlive:false
			}
		}, 
		/* 隐私政策 */
		{
			path: '/privacyPolicy',
			name: 'privacyPolicy',
			component: () => import('./views/front/privacyPolicy.vue'),
			meta: {
				requireLogin: false,
				keepAlive:false
			}
		}, 
		
		/* 后台登录页 */
		{
			// path: '/admin/login',
			path: '/adminLogin',
			name: 'login',
			component: () => import('./views/admin/Login'),
			meta: {
				requireLogin: false,
				keepAlive:false
			}
		},
		// //个人信息
		// {
		// 	// path: '/admin/userinfo',
		// 	path: '/adminUserinfo',
		// 	name: 'userinfo',
		// 	component: () => import('./views/admin/authority/user/UserInfo.vue'),
		// },
		// //用户管理
		// {
		// 	// path: '/admin/authority/userindex',
		// 	path: '/adminAuthorityUserindex',
		// 	name: 'userindex',
		// 	component: () => import('./views/admin/authority/user/UserIndex.vue'),
		// }, 
		// //内容管理-栏目管理
		// {
		// 	// path: '/admin/content/channelindex',
		// 	path: '/adminContentChannelindex',
		// 	name: 'channelindex',
		// 	component: () => import('./views/admin/content/channel/ChannelIndex.vue'),
		// }, 
		// {
		// 	// path: '/admin/content/channel_add',
		// 	path: '/adminContentChannel_add',
		// 	name: 'channel_add',
		// 	component: () => import('./views/admin/content/channel/ChannelAdd.vue'),
		// }, 
		// {
		// 	// path: '/admin/content/channel_edit',
		// 	path: '/adminContentChannel_edit',
		// 	name: 'channel_edit',
		// 	component: () => import('./views/admin/content/channel/ChannelEdit.vue'),
		// }, 
		// // 新闻管理-文章管理
		// {
		// 	// path: '/admin/news/articleindex',
		// 	path: '/adminIndex/articleindex',
		// 	name: 'articleindex',
		// 	component: () => import('./views/admin/news/ArticleIndex.vue'),
		// },
		// {
		// 	// path: '/admin/news/article_add',
		// 	path: '/adminNewsArticle_add',
		// 	name: 'article_add',
		// 	component: () => import('./views/admin/news/ArticleAdd.vue'),
		// }, 
		// {
		// 	// path: '/admin/news/article_edit',
		// 	path: '/adminNewsArticle_edit',
		// 	name: 'article_edit',
		// 	component: () => import('./views/admin/news/ArticleEdit.vue'),
		// }, 
		// //业务管理
		// {
		// 	// path: '/admin/service/serviceindex',
		// 	path: '/adminIndex/serviceindex',
		// 	name: 'serviceindex',
		// 	component: () => import('./views/admin/service/ServiceIndex.vue'),
		// },
		// {
		// 	// path: '/admin/service/service_add',
		// 	path: '/adminServiceService_add',
		// 	name: 'service_add',
		// 	component: () => import('./views/admin/service/ServiceAdd.vue'),
		// }, 
		// {
		// 	// path: '/admin/service/service_edit',
		// 	path: '/adminServiceService_edit',
		// 	name: 'service_edit',
		// 	component: () => import('./views/admin/service/ServiceEdit.vue'),
		// }, 
		// //律师管理
		// {
		// 	// path: '/admin/lawyer/lawyerindex',
		// 	path: '/adminLawyerLawyerindex',
		// 	name: 'lawyerindex',
		// 	component: () => import('./views/admin/lawyer/LawyerIndex.vue'),
		// },
		// {
		// 	// path: '/admin/lawyer/lawyer_add',
		// 	path: '/adminLawyerLawyer_add',
		// 	name: 'lawyer_add',
		// 	component: () => import('./views/admin/lawyer/LawyerAdd.vue'),
		// }, 
		// {
		// 	// path: '/admin/lawyer/lawyer_edit',
		// 	path: '/adminLawyerLawyer_edit',
		// 	name: 'lawyer_edit',
		// 	component: () => import('./views/admin/lawyer/LawyerEdit.vue'),
		// },  
		// //和华文化
		// {
		// 	// path: '/admin/culture/cultureindex',
		// 	path: '/adminCultureCultureindex',
		// 	name: 'cultureindex',
		// 	component: () => import('./views/admin/culture/CultureIndex.vue'),
		// },
		// {
		// 	// path: '/admin/culture/culture_add',
		// 	path: '/adminCultureCulture_add',
		// 	name: 'culture_add',
		// 	component: () => import('./views/admin/culture/CultureAdd.vue'),
		// }, 
		// {
		// 	// path: '/admin/culture/culture_edit',
		// 	path: '/adminCultureCulture_edit',
		// 	name: 'culture_edit',
		// 	component: () => import('./views/admin/culture/CultureEdit.vue'),
		// }, 
		// //留言管理
		// {
		// 	// path: '/admin/leaveMassage/leaveMassageindex',
		// 	path: '/adminLeaveMassageLeaveMassageindex',
		// 	name: 'leaveMassageindex',
		// 	component: () => import('./views/admin/leaveMassage/LeaveMassageIndex.vue'),
		// },
		// {
		// 	// path: '/admin/leaveMassage/leaveMassage_add',
		// 	path: '/adminLeaveMassageLeaveMassage_add',
		// 	name: 'leaveMassage_add',
		// 	component: () => import('./views/admin/leaveMassage/LeaveMassageAdd.vue'),
		// }, 
		// {
		// 	// path: '/admin/leaveMassage/leaveMassage_edit',
		// 	path: '/adminLeaveMassageLeaveMassage_edit',
		// 	name: 'leaveMassage_edit',
		// 	component: () => import('./views/admin/leaveMassage/LeaveMassageEdit.vue'),
		// }, 
		// //关于我们
		// {
		// 	// path: '/admin/aboutUs/aboutUsindex',
		// 	path: '/adminAboutUsAboutUsindex',
		// 	name: 'aboutUsindex',
		// 	component: () => import('./views/admin/aboutUs/AboutUsIndex.vue'),
		// },
		// {
		// 	// path: '/admin/aboutUs/aboutUs_add',
		// 	path: '/adminAboutUsAboutUs_add',
		// 	name: 'aboutUs_add',
		// 	component: () => import('./views/admin/aboutUs/AboutUsAdd.vue'),
		// }, 
		// {
		// 	// path: '/admin/aboutUs/aboutUs_edit',
		// 	path: '/adminAboutUsAboutUs_edit',
		// 	name: 'aboutUs_edit',
		// 	component: () => import('./views/admin/aboutUs/AboutUsEdit.vue'),
		// }, 
		// //加入我们
		// {
		// 	// path: '/admin/joinUs/joinUsindex',
		// 	path: '/adminJoinUsJoinUsindex',
		// 	name: 'joinUsindex',
		// 	component: () => import('./views/admin/joinUs/JoinUsIndex.vue'),
		// },
		// {
		// 	// path: '/admin/joinUs/joinUs_add',
		// 	path: '/adminJoinUsJoinUs_add',
		// 	name: 'joinUs_add',
		// 	component: () => import('./views/admin/joinUs/JoinUsAdd.vue'),
		// }, 
		// {
		// 	// path: '/admin/joinUs/joinUs_edit',
		// 	path: '/adminJoinUsJoinUs_edit',
		// 	name: 'joinUs_edit',
		// 	component: () => import('./views/admin/joinUs/JoinUsEdit.vue'),
		// }, 
		// //招聘管理
		// {
		// 	// path: '/admin/recruit/recruitindex',
		// 	path: '/adminRecruitRecruitindex',
		// 	name: 'recruitindex',
		// 	component: () => import('./views/admin/recruit/RecruitIndex.vue'),
		// }, 
		/* 后台主页 */
		{
			// path: '/admin/index',
			path: '/adminIndex',
			name: 'index',
			component: () => import('./views/admin/Index'),
			// component: () => import('./views/admin/news/ArticleIndex.vue'),
			children: [
				//个人信息
				{
					// path: '/admin/userinfo',
					path: '/adminIndex/userinfo',
					// path: '/adminUserinfo',
					name: 'userinfo',
					component: () => import('./views/admin/authority/user/UserInfo.vue'),
				},
				//用户管理
				{
					// path: '/admin/authority/userindex',
					path: '/adminIndex/userindex',
					name: 'userindex',
					component: () => import('./views/admin/authority/user/UserIndex.vue'),
				}, 
				//内容管理-栏目管理
				{
					// path: '/admin/content/channelindex',
					path: '/adminIndex/channelindex',
					name: 'channelindex',
					component: () => import('./views/admin/content/channel/ChannelIndex.vue'),
				}, 
				{
					// path: '/admin/content/channel_add',
					path: '/adminIndex/channel_add',
					name: 'channel_add',
					component: () => import('./views/admin/content/channel/ChannelAdd.vue'),
				}, 
				{
					// path: '/admin/content/channel_edit',
					path: '/adminIndex/channel_edit',
					name: 'channel_edit',
					component: () => import('./views/admin/content/channel/ChannelEdit.vue'),
				}, 
				//内容管理-轮播图管理
				// {
				// 	path: '/admin/content/slideshowindex',
				// 	name: 'slideshowindex',
				// 	component: () => import('./views/admin/content/slideshow/SlideshowIndex.vue'),
				// }, 
				// //业务管理-业务景区
				// {
				// 	path: '/admin/business/scenicindex',
				// 	name: 'scenicindex',
				// 	component: () => import('./views/admin/business/scenic/ScenicIndex.vue'),
				// }, 
				// {
				// 	path: '/admin/business/scenic_add',
				// 	name: 'scenic_add',
				// 	component: () => import('./views/admin/business/scenic/ScenicAdd.vue'),
				// }, 
				// {
				// 	path: '/admin/business/scenic_edit',
				// 	name: 'scenic_edit',
				// 	component: () => import('./views/admin/business/scenic/ScenicEdit.vue'),
				// }, 
				// //业务管理-软件成果
				// {
				// 	path: '/admin/business/softwareindex',
				// 	name: 'softwareindex',
				// 	component: () => import('./views/admin/business/software/SoftwareIndex.vue'),
				// }, 
				// {
				// 	path: '/admin/business/software_add',
				// 	name: 'software_add',
				// 	component: () => import('./views/admin/business/software/SoftwareAdd.vue'),
				// }, 
				// {
				// 	path: '/admin/business/software_edit',
				// 	name: 'software_edit',
				// 	component: () => import('./views/admin/business/software/SoftwareEdit.vue'),
				// }, 
				// 新闻管理-文章管理
				{
					// path: '/admin/news/articleindex',
					path: '/adminIndex/articleindex',
					name: 'articleindex',
					component: () => import('./views/admin/news/ArticleIndex.vue'),
				},
				{
					// path: '/admin/news/article_add',
					path: '/adminIndex/article_add',
					name: 'article_add',
					component: () => import('./views/admin/news/ArticleAdd.vue'),
				}, 
				{
					// path: '/admin/news/article_edit',
					path: '/adminIndex/article_edit',
					name: 'article_edit',
					component: () => import('./views/admin/news/ArticleEdit.vue'),
				}, 
				//业务管理
				{
					// path: '/admin/service/serviceindex',
					path: '/adminIndex/serviceindex',
					name: 'serviceindex',
					component: () => import('./views/admin/service/ServiceIndex.vue'),
				},
				{
					// path: '/admin/service/service_add',
					path: '/adminIndex/service_add',
					name: 'service_add',
					component: () => import('./views/admin/service/ServiceAdd.vue'),
				}, 
				{
					// path: '/admin/service/service_edit',
					path: '/adminIndex/service_edit',
					name: 'service_edit',
					component: () => import('./views/admin/service/ServiceEdit.vue'),
				}, 
				//律师管理
				{
					// path: '/admin/lawyer/lawyerindex',
					path: '/adminIndex/lawyerindex',
					name: 'lawyerindex',
					component: () => import('./views/admin/lawyer/LawyerIndex.vue'),
				},
				{
					// path: '/admin/lawyer/lawyer_add',
					path: '/adminIndex/lawyer_add',
					name: 'lawyer_add',
					component: () => import('./views/admin/lawyer/LawyerAdd.vue'),
				}, 
				{
					// path: '/admin/lawyer/lawyer_edit',
					path: '/adminIndex/lawyer_edit',
					name: 'lawyer_edit',
					component: () => import('./views/admin/lawyer/LawyerEdit.vue'),
				},  
				//和华文化
				{
					// path: '/admin/culture/cultureindex',
					path: '/adminIndex/cultureindex',
					name: 'cultureindex',
					component: () => import('./views/admin/culture/CultureIndex.vue'),
				},
				{
					// path: '/admin/culture/culture_add',
					path: '/adminIndex/culture_add',
					name: 'culture_add',
					component: () => import('./views/admin/culture/CultureAdd.vue'),
				}, 
				{
					// path: '/admin/culture/culture_edit',
					path: '/adminIndex/culture_edit',
					name: 'culture_edit',
					component: () => import('./views/admin/culture/CultureEdit.vue'),
				}, 
				//留言管理
				{
					// path: '/admin/leaveMassage/leaveMassageindex',
					path: '/adminIndex/leaveMassageindex',
					name: 'leaveMassageindex',
					component: () => import('./views/admin/leaveMassage/LeaveMassageIndex.vue'),
				},
				{
					// path: '/admin/leaveMassage/leaveMassage_add',
					path: '/adminIndex/leaveMassage_add',
					name: 'leaveMassage_add',
					component: () => import('./views/admin/leaveMassage/LeaveMassageAdd.vue'),
				}, 
				{
					// path: '/admin/leaveMassage/leaveMassage_edit',
					path: '/adminIndex/leaveMassage_edit',
					name: 'leaveMassage_edit',
					component: () => import('./views/admin/leaveMassage/LeaveMassageEdit.vue'),
				}, 
				//关于我们
				{
					// path: '/admin/aboutUs/aboutUsindex',
					path: '/adminIndex/aboutUsindex',
					name: 'aboutUsindex',
					component: () => import('./views/admin/aboutUs/AboutUsIndex.vue'),
				},
				{
					// path: '/admin/aboutUs/aboutUs_add',
					path: '/adminIndex/aboutUs_add',
					name: 'aboutUs_add',
					component: () => import('./views/admin/aboutUs/AboutUsAdd.vue'),
				}, 
				{
					// path: '/admin/aboutUs/aboutUs_edit',
					path: '/adminIndex/aboutUs_edit',
					name: 'aboutUs_edit',
					component: () => import('./views/admin/aboutUs/AboutUsEdit.vue'),
				}, 
				//加入我们
				{
					// path: '/admin/joinUs/joinUsindex',
					path: '/adminIndex/joinUsindex',
					name: 'joinUsindex',
					component: () => import('./views/admin/joinUs/JoinUsIndex.vue'),
				},
				{
					// path: '/admin/joinUs/joinUs_add',
					path: '/adminIndex/joinUs_add',
					name: 'joinUs_add',
					component: () => import('./views/admin/joinUs/JoinUsAdd.vue'),
				}, 
				{
					// path: '/admin/joinUs/joinUs_edit',
					path: '/adminIndex/joinUs_edit',
					name: 'joinUs_edit',
					component: () => import('./views/admin/joinUs/JoinUsEdit.vue'),
				}, 
				//招聘管理
				{
					// path: '/admin/recruit/recruitindex',
					path: '/adminIndex/recruitindex',
					name: 'recruitindex',
					component: () => import('./views/admin/recruit/RecruitIndex.vue'),
				}, 
			]
		}
	]

})
router.beforeEach(async(to, from, next) => {
	console.log(!to.matched.some(r => r.meta.requireLogin))
	console.log(r => r.meta.requireLogin)

	// if(to.path.includes('admin')){
		document.title = "和华利盛"
	// }
	if (!to.matched.some(r => r.meta.requireLogin)) {
		next();
	} else {
		if (token.get()) {
			next()
		} else {
			if (to.path === '/adminLogin') {
				next()
			} else {
				next('/adminLogin')
			}
		}
	}
})

export default router
